import { useConstructionSiteCardContext } from "@/components/card/construction-site-card/context";
import { UnstyledIconButton, toast, useAuthContext, useTargetValidation } from "@msuite/picasso";
import { type FC, useState } from "react";
import { TbCornerUpLeft } from "react-icons/tb";
import { useTicketCardContext } from "../context";

export const TicketRemover: FC = () => {
	/** Context */
	const { onRemoveTicket, ticketIndexOverride, constructionSite } =
		useConstructionSiteCardContext();
	const { ticket, ticketIndex } = useTicketCardContext();
	const { userId, validation } = useAuthContext();

	const userIsOwner = useTargetValidation(
		(constructionSite?.bauleiter ?? []).concat(constructionSite?.currentDeputies ?? []),
		userId,
		validation?.isAdmin,
	);

	/** State */
	const [isLoading, setIsLoading] = useState<boolean>(false);

	/** Functions */
	async function handleOnTicketRemove() {
		try {
			setIsLoading(true);
			await onRemoveTicket?.(ticket, ticketIndexOverride ?? ticketIndex);
		} catch (error) {
			console.error(error);
			toast.error("Ticket konnte nicht entfernt werden");
		} finally {
			setIsLoading(false);
		}
	}

	if (!userIsOwner) return null;

	/** Render */
	return (
		<UnstyledIconButton
			placeSelf="center"
			justifySelf="center"
			alignSelf="center"
			icon={<TbCornerUpLeft />}
			aria-label="Ticket entfernen"
			size="sm"
			variant="ghost"
			rounded="full"
			isLoading={isLoading}
			onClick={handleOnTicketRemove}
			_hover={{ backgroundColor: "transparent" }}
		/>
	);
};
